import React from 'react'

import IconCircledCheck from '../icons/IconCircledCheck'

import Section, { SectionProps } from './Section'

import './TridentSection.scss'

export type TridentItem = {
  heading: string
  description: string
}

const TridentSection = (
  props: Omit<SectionProps, 'children'> & {
    heading: string
    items: [TridentItem, TridentItem, TridentItem]
  },
) => {
  return (
    <Section className="trident" mainTitle={props.heading} {...props}>
      <div className="trident__columns">
        {props.items.map(({ heading, description }, i) => {
          return (
            <div className="trident__item" key={i}>
              <div className="trident__subheading">
                <IconCircledCheck />
                <h3>{heading}</h3>
              </div>
              <p>{description}</p>
            </div>
          )
        })}
      </div>
    </Section>
  )
}

export default TridentSection
